import React from 'react';
import { LegalPage } from '../components/platform/LegalPage';
import { TERMS } from '../content/legal';

export default function TermsOfService() {
  return (
    <LegalPage testId="terms-of-service-page" title="Terms of Service" sections={TERMS}
      intro="The agreement that governs demo bookings, the 14-day free trial, monthly CRM subscriptions, the one-time website setup fee, and use of the DecoWorkflow website builder, CRM and production tools." />
  );
}
